import React from 'react';
import AppRouter from './components/Routes/AppRouter';
import Loader from "./components/Elements/Loader";

const App = () => {
  return (
    <div className="App">
      <AppRouter />
      <Loader />  
    </div>
  );
}

export default App;